import { useMatches } from "@remix-run/react";
export default function useLosseConfig() {
    var _a, _b;
    const matches = useMatches();
    return (_b = (_a = matches === null || matches === void 0 ? void 0 : matches[0]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.config;
}
